export default "__VITE_ASSET__ClqCWSMn__$_?inline__"